import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { translate } from "react-i18next";
import { MenuItem } from "@material-ui/core";
import InputFormat from "../inputForm";

import { genders } from "../../utils/setting";
import { styles } from "./styles";
class SelectGender extends Component {
  render() {
    const {
      classes,
      t,
      SelectProps = {},
      InputLabelProps = {},
      ...props
    } = this.props;
    return (
      <InputFormat
        {...props}
        select
        SelectProps={{
          displayEmpty: true,
          ...SelectProps
        }}
        InputLabelProps={{
          ...InputLabelProps
        }}
      >
        <MenuItem>{t("pls_select")}</MenuItem>
        {genders.map((gender, index) => (
          <MenuItem key={index} value={gender.value}>
            {t(gender.label)}
          </MenuItem>
        ))}
      </InputFormat>
    );
  }
}

SelectGender.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default translate("translations")(
  withStyles(styles, { withTheme: true })(SelectGender)
);
